document.addEventListener("DOMContentLoaded", () => {

  // Byt text på Add to cart-knappen (Dawn)
  const btn = document.querySelector('button[type="submit"][name="add"]');
  if (btn) btn.textContent = "Betala 695kr & skicka in formulär >>";
  
});
